import React, { useState } from 'react';
import { CheckCircle, ChevronDown, Check } from 'lucide-react';
const modules = [{
  icon: '📘',
  title: 'TOMO 1 – CLASES PARA PRINCIANTES',
  target: 'Construí alumnos desde cero sin improvisar',
  desc: 'Este tomo incluye una planificación completa para enseñar a jugadores que recién comienzan en el pádel.\n\nEncontrarás clases estructuradas paso a paso, ejercicios progresivos, dinámicas simples y objetivos claros para que cualquier principiante pueda aprender de forma rápida y divertida.',
  bullets: ['Más de 30 clases listas para aplicar', 'Ejercicios de coordinación, control y continuidad', 'Juegos adaptados para principiantes', 'Planificaciones de 30, 45 y 60 minutos', 'Correcciones básicas y errores frecuentes'],
  footer: 'Ideal para profesores que trabajan con alumnos sin experiencia y necesitan material listo para usar.'
}, {
  icon: '📙',
  title: 'TOMO 2 – CLASES NIVEL INICIAL',
  target: 'Transformá principiantes en jugadores consistentes',
  desc: 'Una vez dominadas las bases, este tomo te permite desarrollar jugadores más seguros y confiados dentro de la cancha.\n\nIncluye progresiones técnicas, ejercicios de dirección, control y posicionamiento para que tus alumnos comiencen a jugar puntos reales con mayor soltura.',
  bullets: ['Clases estructuradas de nivel inicial', 'Ejercicios de precisión y continuidad', 'Desarrollo de la confianza en juego real', 'Juegos técnicos y tácticos', 'Evaluaciones prácticas'],
  footer: 'Perfecto para mantener motivados a los alumnos durante sus primeros meses de aprendizaje.'
}, {
  icon: '📕',
  title: 'TOMO 3 – NIVEL INTERMEDIO',
  target: 'Enseñá a pensar el juego, no solo a golpear',
  desc: 'Este tomo está enfocado en desarrollar la toma de decisiones dentro de la cancha.\n\nTus alumnos aprenderán a elegir mejor los golpes, controlar ritmos, construir puntos y comprender situaciones tácticas básicas.',
  bullets: ['Más de 30 sesiones intermedias listas', 'Ejercicios de transición y posicionamiento', 'Desarrollo de lectura táctica', 'Juegos de presión y toma de decisiones', 'Situaciones reales de partido'],
  footer: 'Ideal para profesores que quieren llevar a sus alumnos al siguiente nivel competitivo.'
}, {
  icon: '📗',
  title: 'TOMO 4 – TÉCNICA POR GOLPE',
  target: 'Tu manual definitivo de corrección técnica',
  desc: 'Una guía completa para identificar errores, corregirlos rápidamente y aplicar ejercicios específicos para cada golpe del pádel.\n\nIncluye progresiones detalladas para derecha, revés, volea, bandeja, smash y salida de pared.',
  bullets: ['Correcciones rápidas en cancha', 'Errores más comunes y soluciones prácticas', 'Ejercicios específicos para cada golpe', 'Indicadores de progreso', 'Métodos de enseñanza simplificados'],
  footer: 'El recurso perfecto para mejorar la calidad de tus correcciones y clases.'
}, {
  icon: '📓',
  title: 'TOMO 5 – TÁCTICA Y SITUACIONES REALES',
  target: 'Convertí jugadores técnicos en jugadores inteligentes',
  desc: 'Aquí encontrarás todo lo necesario para enseñar estrategia, posicionamiento y toma de decisiones dentro de un partido.\n\nEste tomo ayuda a que los alumnos entiendan cuándo atacar, cuándo defender y cómo jugar en pareja de forma efectiva.',
  bullets: ['Situaciones reales de partido', 'Sistemas de ataque y defensa', 'Juegos tácticos listos para aplicar', 'Ejercicios de posicionamiento', 'Desarrollo del juego en pareja'],
  footer: 'Fundamental para profesores que quieren enseñar pádel moderno y competitivo.'
}, {
  icon: '📔',
  title: 'TOMO 6 – RECURSOS, PLANTILLAS Y MATERIAL LISTO',
  target: 'Ahorrá horas de planificación cada semana',
  desc: 'Un banco completo de recursos profesionales para organizar alumnos, planificar clases y gestionar grupos de forma eficiente.\n\nTodo listo para imprimir, completar y utilizar inmediatamente.',
  bullets: ['Fichas de alumnos', 'Planificaciones anuales, mensuales y semanales', 'Evaluaciones listas para usar', 'Rutinas prearmadas', 'Juegos y actividades organizadas'],
  footer: 'El tomo que convierte el caos en organización profesional.'
}, {
  icon: '🏆',
  title: 'SISTEMA DE ALUMNOS',
  target: 'El método para fidelizar alumnos y aumentar la retención',
  desc: 'No alcanza con enseñar bien. También hay que lograr que los alumnos permanezcan, progresen y recomienden tus clases.\n\nEste sistema te enseña cómo organizar información, realizar seguimientos y construir una experiencia profesional que genere continuidad.',
  bullets: ['Fichas de seguimiento', 'Evaluaciones periódicas', 'Control de asistencia', 'Sistemas de motivación', 'Estrategias de retención'],
  footer: 'Ideal para profesores que quieren construir un negocio estable y profesional.'
}, {
  icon: '🚀',
  title: 'PROGRAMA 90 DÍAS',
  target: 'El plan completo para transformar alumnos en jugadores',
  desc: 'Una hoja de ruta de 12 semanas que te indica exactamente qué enseñar, cuándo hacerlo y cómo medir el progreso.\n\nSin improvisación. Sin dudas. Con objetivos claros desde el primer día.',
  bullets: ['Programa estructurado de 90 días', 'Plan semanal detallado', 'Evaluaciones de progreso', 'Rutinas de entrenamiento', 'Objetivos por etapas'],
  footer: 'La herramienta perfecta para ofrecer procesos de entrenamiento profesionales y generar resultados visibles.'
}];
export function Modules() {
  const [openIndex, setOpenIndex] = useState<number | null>(0);
  return <section className="py-20 px-4 bg-[#0A1628]" data-id="element-198">
      <div className="max-w-3xl mx-auto" data-id="element-199">
        <h2 className="text-4xl md:text-5xl font-anton text-center mb-2 text-white uppercase tracking-wide" data-id="element-200">
          LOS 6 MÓDULOS
        </h2>
        <p className="text-center text-[#C6F432] font-medium mb-10 text-sm md:text-base" data-id="element-201">
          Tu sistema completo de clases de pádel
        </p>

        <div className="space-y-3 mb-12" data-id="element-202">
          {modules.map((mod, i) => {
          const isOpen = openIndex === i;
          return <div key={i} className={`bg-[#0F1F3D] border rounded-xl overflow-hidden transition-all duration-300 ${isOpen ? 'border-[#C6F432]/50 shadow-[0_0_20px_rgba(198,244,50,0.1)]' : 'border-white/5 hover:border-white/20'}`} data-id="element-203">
                <button onClick={() => setOpenIndex(isOpen ? null : i)} className="w-full flex items-center p-4 md:p-5 text-left transition-colors" data-id="element-204">
                  <span className="text-2xl mr-4 shrink-0" data-id="element-205">{mod.icon}</span>
                  <div className="flex-1" data-id="element-206">
                    <h3 className={`font-bold text-sm md:text-base flex items-center gap-2 ${isOpen ? 'text-[#C6F432]' : 'text-white'}`} data-id="element-207">
                      {mod.title}
                    </h3>
                  </div>
                  <ChevronDown className={`text-gray-400 shrink-0 transition-transform duration-300 ${isOpen ? 'rotate-180 text-[#C6F432]' : ''}`} size={20} data-id="element-208" />
                </button>
                <div className={`grid transition-all duration-300 ease-in-out ${isOpen ? 'grid-rows-[1fr] opacity-100' : 'grid-rows-[0fr] opacity-0'}`} data-id="element-209">
                  <div className="overflow-hidden" data-id="element-210">
                    <div className="px-5 pb-6 pt-2 border-t border-white/5" data-id="element-211">
                      <p className="text-white font-bold mb-4 text-lg flex items-start gap-2" data-id="element-212">
                        <span className="shrink-0" data-id="element-213">🎯</span> {mod.target}
                      </p>

                      <div className="text-gray-300 text-sm md:text-base space-y-4 mb-6 whitespace-pre-line" data-id="element-214">
                        {mod.desc}
                      </div>

                      <ul className="space-y-2.5 mb-6" data-id="element-215">
                        {mod.bullets.map((bullet, j) => <li key={j} className="flex items-start gap-2.5 text-gray-200 text-sm md:text-base" data-id="element-216">
                            <Check className="text-[#C6F432] shrink-0 mt-0.5" size={18} data-id="element-217" />
                            <span data-id="element-218">{bullet}</span>
                          </li>)}
                      </ul>

                      <div className="bg-[#0A1628] p-4 rounded-lg border border-white/5 text-sm text-gray-300 italic" data-id="element-219">
                        {mod.footer}
                      </div>
                    </div>
                  </div>
                </div>
              </div>;
        })}
        </div>

        {/* Texto de Cierre */}
        <div className="bg-gradient-to-br from-[#0F1F3D] to-[#0A1628] border border-[#C6F432]/30 rounded-2xl p-6 md:p-10 shadow-xl text-center" data-id="element-220">
          <h3 className="text-xl md:text-2xl font-bold text-white mb-6" data-id="element-221">
            En total recibís más de{' '}
            <span className="text-[#C6F432]" data-id="element-222">14 recursos profesionales</span>{' '}
            diseñados para resolverte prácticamente todo un año de trabajo como
            profesor/a de pádel.
          </h3>

          <div className="flex flex-wrap justify-center gap-3 md:gap-6 mb-8" data-id="element-223">
            <span className="flex items-center gap-2 text-sm md:text-base text-gray-200" data-id="element-224">
              <CheckCircle className="text-[#C6F432]" size={18} data-id="element-225" /> Clases listas
            </span>
            <span className="flex items-center gap-2 text-sm md:text-base text-gray-200" data-id="element-226">
              <CheckCircle className="text-[#C6F432]" size={18} data-id="element-227" /> Ejercicios
              listos
            </span>
            <span className="flex items-center gap-2 text-sm md:text-base text-gray-200" data-id="element-228">
              <CheckCircle className="text-[#C6F432]" size={18} data-id="element-229" /> Juegos listos
            </span>
            <span className="flex items-center gap-2 text-sm md:text-base text-gray-200" data-id="element-230">
              <CheckCircle className="text-[#C6F432]" size={18} data-id="element-231" />{' '}
              Planificaciones listas
            </span>
            <span className="flex items-center gap-2 text-sm md:text-base text-gray-200" data-id="element-232">
              <CheckCircle className="text-[#C6F432]" size={18} data-id="element-233" /> Seguimiento
              de alumnos
            </span>
            <span className="flex items-center gap-2 text-sm md:text-base text-gray-200" data-id="element-234">
              <CheckCircle className="text-[#C6F432]" size={18} data-id="element-235" /> Programa
              completo de 90 días
            </span>
          </div>

          <p className="text-lg text-gray-300 font-medium" data-id="element-236">
            Todo pensado para que enseñes mejor, ahorres tiempo y
            profesionalices tus clases desde el primer día.
          </p>
        </div>
      </div>
    </section>;
}